export default "__VITE_ASSET__BJ6fV2wa__"